import { AbstractApi } from '../../../common/api'
import { LoginInfo, RegisterInfo } from '../types/auth.types'

class AuthApi extends AbstractApi {
  protected url = '/auth'

  public async register(registerInfo: RegisterInfo): Promise<any> {
    const { data: response } = await this.post(this.url.concat('/register'), registerInfo)

    return response
  }

  public async login(dto: LoginInfo): Promise<any> {
    const { data: response } = await this.post(this.url.concat('/login'), dto)

    return response
  }

  public async forgotPassword(email: string) {
    const { data: response } = await this.post(this.url.concat('/forgot'), { email })

    return response
  }

  public async logout(): Promise<any> {
    const { data: response } = await this.post(this.url.concat('/logout'), {})

    return response
  }
}

export const authApi = new AuthApi()
